/**
 * AI-205: recover numeric metric IDs from results-portal paths.
 * Keep in sync with apps/tiny-ai/.../page-submetric-id.ts
 */

const METRIC_PATH_ID = /\/metrics\/[^/?#]+\/(\d+)(?:\/|$|\?|#)/i;
const METRIC_TRAILING_ID = /\/metrics\/(?:[^/?#]+\/)*(\d+)(?:\/|$|\?|#)/i;

export function extractSubMetricIdFromPath(
  pathOrUrl: string | undefined | null,
): string | undefined {
  if (!pathOrUrl) return undefined;
  let path = pathOrUrl.trim();
  try {
    if (/^https?:\/\//i.test(path)) {
      path = new URL(path).pathname;
    }
  } catch {
    // keep raw string
  }
  path = path.split(/[?#]/)[0] ?? path;

  const primary = path.match(METRIC_PATH_ID);
  if (primary?.[1]) return primary[1];
  const fallback = path.match(METRIC_TRAILING_ID);
  return fallback?.[1];
}
